import Table, { ColumnsType } from "antd/es/table";
import { useSelector } from "react-redux";
import { Modal, Space, Spin, Tag } from "antd";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useEffect, useState } from "react";
import { ExclamationCircleFilled } from '@ant-design/icons';
import { RootState } from "../../../store/store";
import { RingotelUser, useDeleteRingotelUser, useGetRingotelUsersByAccount } from "../../../hooks/apis/ringotelUsers.api";
import EditRingtelUserModal from "../../Modal/EditRingoteUserModal";
import { useGetAllUsers } from "../../../hooks/apis/user.api";
const { confirm } = Modal;


const RingotelUsersTable = () => {
    const { allUsers: users } = useSelector((state: RootState) => state.users)
    const { selectedAccount } = useSelector((state: RootState) => state.admin)
    const { data: ringotelUsers } = useSelector((state: RootState) => state.ringotelUsers)
    const { refetch: refetchRingotelUsers, isFetching: isLoadingRingotelUsers } = useGetRingotelUsersByAccount(selectedAccount)
      const { isRefetching: isRefetchingAllUsers, isLoading: isLoadingAllUsers } = useGetAllUsers()

    const { mutate: deleteRingotelUserMutate } = useDeleteRingotelUser()
    const [editRingotelUserModal, setEditRingotelUserModal] = useState(false)
    const [editData, setEditData] = useState<RingotelUser | null>(null)


    const showDeleteConfirm = (record: RingotelUser) => {
        confirm({
            title: 'Are you sure you want to delete this account?',
            icon: <ExclamationCircleFilled />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                deleteRingotelUserMutate(record.user_id)
            },
        });
    };
    useEffect(() => {
        refetchRingotelUsers()
    }, [selectedAccount])

    const columns: ColumnsType<RingotelUser> = [
        {
            title: 'User Name',
            dataIndex: 'user_id',
            key: 'user_id',
            render: (_, { user_id }) =>  {
                const user = users.find((u) => u.id === user_id);
                if (!user) {
                    return <span style={{ color: "red" }}>User not found</span>;
                }
                return (
                    <a target="_blank" href={`${process.env.REACT_APP_ACCOUNT_URL}/user/${user_id}`}>{`${user.first_name} ${user.last_name}`}</a>
                )
            }
                
        },
        {
            title: 'Extension',
            dataIndex: 'ext',
            key: 'ext',
            render: (_, { user_ext }) => <Tag>{user_ext}</Tag>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    {
                        <CiEdit style={{ cursor: "pointer" }} onClick={() => {
                            setEditData(record)
                            setEditRingotelUserModal(true)
                        }}
                        />
                    }
                    {

                        <MdDeleteOutline onClick={() => {
                            showDeleteConfirm(record)
                        }} style={{ cursor: "pointer" }} />
                    }
                </Space>
            ),
        },
    ];

    if (isLoadingRingotelUsers || isLoadingAllUsers || isRefetchingAllUsers) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                <Spin />
            </div>
        );
    }

    return <div>
        {
            editRingotelUserModal && selectedAccount && <EditRingtelUserModal setIsModalOpen={setEditRingotelUserModal} isModalOpen={editRingotelUserModal} editData={editData || null} />
        }
        <Table loading={(isLoadingRingotelUsers || isLoadingAllUsers || isRefetchingAllUsers) && ringotelUsers.filter(ringotelUser => ringotelUser.account_id === selectedAccount).length === 0} scroll={{ y: 450 }} style={{ width: "100%"}} columns={columns} pagination={ringotelUsers.filter(ringotelUser => ringotelUser.account_id === selectedAccount).length > 10 && { position: ["bottomCenter"] }} dataSource={ringotelUsers.filter(ringotelUser => ringotelUser.account_id === selectedAccount)} />
    </div>
}

export default RingotelUsersTable